module.exports = __webpack_public_path__ + "img/16581259_S.2ede0a19.png";